import { getDocumentType } from './utils/document'
import { OnyxDocument } from './types'

import BitwardenIcon from '@/icons/bwi/shield.svg'
import CommunityIcon from '@/icons/bwi/community.svg'
import HelpIcon from '@/icons/bwi/question-circle.svg'
import BlogIcon from '@/icons/bwi/pencil.svg'
import ExternalIcon from '@/icons/bwi/external-link.svg'
import GithubIcon from '@/icons/bwi/github.svg'
import ResourcesIcon from '@/icons/bwi/file-pdf.svg'

export default function SourceBadge({ document }: { document: OnyxDocument }) {
  const sourceType = getDocumentType(document)
  let Icon: typeof BitwardenIcon | null = null
  switch (sourceType) {
    case 'Bitwarden':
      Icon = BitwardenIcon
      break
    case 'Community':
      Icon = CommunityIcon
      break
    case 'Blog':
      Icon = BlogIcon
      break
    case 'Help':
      Icon = HelpIcon
      break
    case 'Resources':
      Icon = ResourcesIcon
      break
    case 'GitHub':
      Icon = GithubIcon
      break
    case 'External':
      Icon = ExternalIcon
      break
  }
  return (
    <div className="flex items-center mb-1">
      {Icon && <Icon className="w-4 h-4 text-primaryBlue mr-2" />}
      <p className="text-xs uppercase tracking-widest text-secondary-800 mb-0">{sourceType}</p>
    </div>
  )
}
